import React from 'react'
import avatar from '../img/avatar.jpg';
import { NavLink } from 'react-router-dom';


function Navbar() {

    return (
        <div className="NavBar" to='fiexd'>
            <nav className="nav">
                <div className="profile">
                    <img src={avatar} alt="" />

                </div>

                <h1><span>Ali Haydar</span></h1>


                <ul className="nav-items container">
                    <li className="nav-item">
                        <NavLink to="/" exact activeClassName="active">
                            Home
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to="/about" exact activeClassName="active">
                            About Me
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to="/portfolios" exact activeClassName="active">
                            Certifications
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to="/projects" exact activeClassName="active">
                            Projects
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to="/myblogs" exact activeClassName="active">
                            Blogs
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to="/contact" exact activeClassName="active">
                            Contact
                        </NavLink>
                    </li>
                </ul>

                <footer className="footer">
                    <p>

                    </p>
                </footer>
            </nav>

        </div>
    )
}

export default Navbar;
